<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap my-2 mx-6 mb-4">
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >First Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                  id="firstName"
                  v-model="formValues.firstName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Father Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                  id="fatherName"
                  v-model="formValues.middleName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Grandfather Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                  id="grandFatherName"
                  v-model="formValues.lastName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >User Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="username"
                  v-model="formValues.username"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="text"
                  @input="formValues.username = formValues.username.toLowerCase()"
                  @keydown.space.prevent
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Email Address</label
            >
            <validation-provider v-slot="{ errors }" rules="required|email">
              <input
                  id="emailAdress"
                  v-model="formValues.email"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="email"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Phone Number</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                phone_regex: '^([+]2519|2519|09|9)\\d{8}|^(0|[+]251|251)\\d{9}',
              }"
            >
              <input
                  id="phoneNumber"
                  v-model="formValues.phoneNumber"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="number"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >User Group</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.userGroupId"
                  :elevation="1"
                  :items="GROUPS"
                  :loading="loading"
                  dense
                  item-text="groupName"
                  item-value="id"
                  solo
                  @change="groupOnChange($event)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Role</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.userRoleId"
                  :elevation="1"
                  :items="FILTERED_ROLES"
                  :loading="roleLoading"
                  dense
                  item-text="roleName"
                  item-value="id"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="showRegion"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Region</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.regionId"
                  :elevation="1"
                  :items="REGIONS"
                  :loading="defaultsLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
                  @change="regionChange($event)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Facility Type</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.facilityTypeId"
                  :elevation="1"
                  :items="FACILITY_TYPES"
                  :loading="facilityTypeLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
                  @change="facilityTypeChange($event)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="showFacility"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Facility</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.userFacilityId"
                  :elevation="1"
                  :items="FILTERED_USER_FACILITIES"
                  :loading="facilityLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="showCpdProvider"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >CPD Provider</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete v-model="formValues.cpdProviderId" :clearable="clearable" :elevation="1"
                              :items="FILTERED_CPD_PROVIDERS"
                              :loading="facilityLoading" :searchable="searchable" dense item-text="trainingCenterName"
                              item-value="id"
                              label="cpd providers" solo></v-autocomplete>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="showAccreditor"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditors</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select v-model="formValues.accreditorId" :clearable="clearable" :elevation="1"
                        :items="FILTERED_ACCREDITORS" :loading="facilityLoading" :searchable="searchable" dense
                        item-text="accreditorName"
                        item-value="id" solo></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div v-if="showEduInstitutions" class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Educational Institutions</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.eduInstitutionId"
                  :elevation="1"
                  :items="UNIVERSITIES"
                  :loading="universityLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="!formValues.editMode"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Password</label
            >
            <validation-provider
                v-slot="{ errors }"
                rules="required"
                vid="confirm"
            >
              <div class="input-icons">
                <!-- <input class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                " v-if="showPassword" type="text" v-model="formValues.password" name="password" /> -->
                <input
                    v-model="formValues.password"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                    type="password"
                />
                <password
                    v-model="formValues.password"
                    :showPassword="true"
                    :strength-meter-only="true"
                />
              </div>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="!formValues.editMode"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Confirm Password</label
            >
            <validation-provider
                v-slot="{ errors }"
                rules="required|confirmed:confirm"
            >
              <div class="input-icons">
                <input
                    v-if="showConfirmPassword"
                    v-model="confirmPassword"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                    name="confirm"
                    type="text"
                />
                <input
                    v-else
                    v-model="confirmPassword"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                    name="confirm"
                    type="password"
                />

                <a class="button" @click="toggleConfirmShow()">
                  <v-icon v-if="showConfirmPassword">
                    mdi-eye-off
                  </v-icon>
                  <v-icon v-else>
                    mdi-eye
                  </v-icon>
                </a>
              </div>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >User's Status</label
            >
            <validation-provider v-slot="{ errors }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-switch
                      v-model="formValues.isActive"
                      color="green"
                      hide-details
                      v-on="on"
                  ></v-switch>
                </template>
                <span>{{
                    formValues.isActive == true ? "Active" : "Not Active"
                  }}</span>
              </v-tooltip>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full">
            <button
                class="
                float-right
                shadow
                bg-teal-600
                hover:bg-teal-600
                focus:shadow-outline focus:outline-none
                text-white
                font-bold
                py-2
                px-4
                rounded
              "
                type="button"
                @click="submit()"
            >
              {{ formValues.editMode ? "Update User" : "Create User" }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {confirmed, email, regex, required} from "vee-validate/dist/rules";
import {RoleService} from "../Role/role.service";
import {UserGroupService} from "../UserGroup/Usergroup.service";
import {TrainingCenterService} from "../../TrainingCenter/training_center.service";
import {AccreditorService} from "../../Accreditors/accreditor.service";
import {getExpertLevels, getFacilityTypes, getRegionList, getUniversities, getUserFacilities,} from "@/utils/helper";
import Password from "vue-password-strength-meter";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("regex", {
  ...regex,
  message: "Names should contain only letters",
});
extend("phone_regex", {
  ...regex,
  message: "Invalid phone number",
});
extend("email", {
  ...email,
  message: "Email must be valid",
});

extend("confirmed", {
  ...confirmed,
  message: "Password doesn't match",
});

export default {
  props: {
    user: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Password,
  },
  data() {
    return {
      formValues: {
        firstName: "",
        middleName: "",
        lastName: "",
        username: "",
        password: "",
        phoneNumber: "",
        email: "",
        userRoleId: null,
        regionId: null,
        expertLevelId: 2,
        userGroupId: null,
        isActive: true,
        facilityTypeId: null,
        userFacilityId: null,
        eduInstitutionId: null,
        cpdProviderId: null,
        accreditorId: null,
        editMode: false,
      },
      showProgress: false,
      // ROLES: [],
      FILTERED_ROLES: [],
      // defaultGroups: null,
      GROUPS: [],
      REGIONS: [],
      EXPERT_LEVELS: [],
      showRegion: true,
      FACILITY_TYPES: [],
      selectedRegion: null,
      FILTERED_USER_FACILITIES: [],
      FILTERED_CPD_PROVIDERS: [],
      FILTERED_ACCREDITORS: [],
      selectedFacilityType: null,
      facilityLoading: false,
      roleLoading: false,
      defaultsLoading: false,
      showPassword: false,
      showConfirmPassword: false,
      confirmPassword: null,
      UNIVERSITIES: [],
      universityLoading: false,
      educationalInstId: null,
      cpdProviderId: null,
      accreditorId: null,
      showEduInstitutions: false,
      showCpdProvider: false,
      showAccreditor: false,
      showFacility: false,
      facilityTypeLoading: false,
      clearable: true,
      searchable: true
    };
  },
  async beforeMount() {
    this.loading = true;
    this.defaultsLoading = true;
    const res = await UserGroupService.getUserGroups();
    if (res.status === 200) {
      this.loading = false;
      this.GROUPS = res.data.rows;
    } else {
      this.loading = false;
      this.$toast.error(
          "There was a problem fetching roles, Please try Again!"
      );
    }
    this.REGIONS = await getRegionList();
    this.EXPERT_LEVELS = await getExpertLevels();
    this.defaultsLoading = false;
  },
  async created() {
    this.facilityTypeLoading = true;
    this.universityLoading = true;
    this.FACILITY_TYPES = await getFacilityTypes();
    this.facilityTypeLoading = false;
    const univResp = await getUniversities();
    this.UNIVERSITIES = (univResp.rows && univResp.rows.length > 0) ? univResp.rows.filter((data) => {
      return data.isActive === true;
    }) : null;
    this.universityLoading = false;
    this.educationalInstId = this.FACILITY_TYPES.filter((data) => {
      return data.code == "EINST";
    })[0].id;
    this.cpdProviderId = this.FACILITY_TYPES.filter((data) => {
      return data.code == "CPDPF";
    })[0].id;
    this.accreditorId = this.FACILITY_TYPES.filter((data) => {
      return data.code == "ACCF";
    })[0].id;

    if (this.user != null) {
      this.formValues = this.user;
      this.formValues.editMode = true;
      this.formValues.userFacilityId = +this.user.userFacilityId;
      this.formValues.facilityTypeId = +this.user.facilityTypeId;
      this.formValues.userRoleId = +this.user.userRoleId;
      this.formValues.userFacilityId = +this.user.userFacilityId;

      this.groupOnChange(this.formValues.userGroupId);
      // this.epxertLevelChange(this.formValues.expertLevelId);
      this.regionChange(this.formValues.regionId, 'init');
      this.facilityTypeChange(this.formValues.facilityTypeId, 'init');
    }
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmShow() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    async groupOnChange(event) {
      this.roleLoading = true;
      const groupId = event;
      const res = await RoleService.getRolesByGroupId(groupId);
      if (res.status === 200) {
        this.loading = false;
        this.FILTERED_ROLES = res.data;

        this.roleLoading = false;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching roles, Please try Again!"
        );

        this.roleLoading = false;
      }
    },
    regionChange(value, from) {
      if (this.showRegion == true) {
        this.selectedRegion = value;
        if (from !== 'init') {
          this.FILTERED_USER_FACILITIES = [];
          this.FILTERED_CPD_PROVIDERS = [];
          this.FILTERED_ACCREDITORS = [];
          this.formValues.accreditorId = null;
          this.formValues.cpdProviderId = null;
          this.formValues.userFacilityId = null;
          this.formValues.eduInstitutionId = null;
        }
        this.selectedFacilityType
            ? this.facilityTypeChange(this.selectedFacilityType)
            : null;
      } else {
        this.selectedRegion = 0;
      }
    },
    async facilityTypeChange(value, from) {
      if (from !== 'init') {
        this.formValues.accreditorId = null;
        this.formValues.cpdProviderId = null;
        this.formValues.userFacilityId = null;
        this.formValues.eduInstitutionId = null;
      }
      this.facilityLoading = true;
      if (value == this.educationalInstId) {
        this.showEduInstitutions = true;
        this.showAccreditor = false;
        this.showCpdProvider = false;
        this.showFacility = false;
        this.selectedFacilityType = +value;
      } else if (value == this.cpdProviderId) {
        this.showEduInstitutions = false;
        this.showCpdProvider = true;
        this.showAccreditor = false;
        this.showFacility = false;
        this.selectedFacilityType = +value;
        const returnedCpdProvider = await TrainingCenterService.getTrainingCentersByLocation(this.selectedRegion);
        this.FILTERED_CPD_PROVIDERS = returnedCpdProvider.filter((data) => {
          return data.isActive == true;
        });
      } else if (value == this.accreditorId) {
        this.showEduInstitutions = false;
        this.showCpdProvider = false;
        this.showAccreditor = true;
        this.showFacility = false;
        this.selectedFacilityType = +value;
        const returnedAccreditor = await AccreditorService.getAccreditorsByLocation(this.selectedRegion);
        this.FILTERED_ACCREDITORS = returnedAccreditor.filter((data) => {
          return data.isActive == true;
        });
      } else {
        this.showEduInstitutions = false;
        this.showAccreditor = false;
        this.showCpdProvider = false;
        this.showFacility = true;
        this.selectedFacilityType = +value;
        const returnedFacilities = await getUserFacilities(
            this.selectedRegion,
            this.selectedFacilityType
        );
        this.FILTERED_USER_FACILITIES = returnedFacilities.filter((data) => {
          return data.isActive == true;
        });

      }
      this.facilityLoading = false;
    },
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("registerOrUpdateUser", this.formValues);
    }
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%);
  border-radius: 4px !important;
}

/* .input-icons i {
  position: absolute;
} */
.button {
  padding: 10px;
  min-width: 40px;
}

.input-field {
  width: 85%;
  padding: 10px;
}
</style>
